export default __webpack_public_path__ + "static/PromptImageOne-863bda1c04fc11c29f3f9ddd1371e5fb.png";